import { render } from "./ClassificationList.vue?vue&type=template&id=f8c6dc28&scoped=true&ts=true"
import script from "./ClassificationList.vue?vue&type=script&lang=ts"
export * from "./ClassificationList.vue?vue&type=script&lang=ts"

import "./ClassificationList.vue?vue&type=style&index=0&id=f8c6dc28&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8c6dc28"]])

export default __exports__